export default () => `// cocoapods
pod 'FlagsmithClient', '~> 1.0.1'
`
